export const getCurrentElapsed = () => (process.env.NODE_ENV === 'test' ? 0 : performance.now());

export const momentLocaleCustomizations = {
  weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'], // short week days for BR
};
